export default __webpack_public_path__ + "static/media/icon9.f9c5e1b8.svg";